import { render, staticRenderFns } from "./categorySheLocaltion.vue?vue&type=template&id=118481de&scoped=true&"
import script from "./categorySheLocaltion.vue?vue&type=script&lang=js&"
export * from "./categorySheLocaltion.vue?vue&type=script&lang=js&"
import style0 from "./categorySheLocaltion.vue?vue&type=style&index=0&id=118481de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118481de",
  null
  
)

export default component.exports